import { Component, OnDestroy, OnInit } from '@angular/core';
import { SidebarModule } from 'primeng/sidebar';
import { firstValueFrom, forkJoin, Subscription } from 'rxjs';
import { AuthenticationManagerService } from '../../../services/authentication-manager.service';
import { LoginFormComponent } from './login-form/login-form.component';
import { AuthService, EventBusService, LocalService, UserActivityService } from 'lib-base';
import { CommonModule, DatePipe } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RegisterFormComponent } from './register-form/register-form.component';
import { PasswordResetFormComponent } from './password-reset-form/password-reset-form.component';
import { EfectuarTramiteEmpresaFormComponent } from './efectuar-tramite-empresa-form/efectuar-tramite-empresa-form.component';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import {ProfileFormComponent} from "../../../pages/tramitante/profile-form/profile-form.component";

@Component({
  selector: 'app-authentication-manager',
  standalone: true,
  imports: [CommonModule, SidebarModule, LoginFormComponent, RegisterFormComponent, PasswordResetFormComponent, TranslateModule, 
    EfectuarTramiteEmpresaFormComponent, ConfirmDialogModule, ProfileFormComponent],
  providers: [DatePipe, ConfirmationService],
  templateUrl: './authentication-manager.component.html',
  styleUrl: './authentication-manager.component.scss'
})
export class AuthenticationManagerComponent implements OnInit, OnDestroy {
  display: boolean = false;

  private _menuOpenSubscription !: Subscription;
  private _menuCloseSubscription !: Subscription;
  private _openTabSubscription !: Subscription;
  private _eventBusSub !: Subscription;
  index: number = 0;

  currentTime !: Date;
  location!: string;
  translations: any = {};

  constructor(private _am: AuthenticationManagerService, private _ls: LocalService, private datePipe: DatePipe, private _eb: EventBusService, private _a: AuthService,
    private _cs: ConfirmationService, private _uas: UserActivityService, private _t: TranslateService
  ) {
    this._menuOpenSubscription = this._am.openSource$.subscribe(key => {
      if (!this._ls.isLoggedIn) {
        this.index = 0;
        this.display = true;
      }
    });

    this._menuCloseSubscription = this._am.closeSource$.subscribe(() => {
      this.display = false;
    });

    this._openTabSubscription = this._am.openTabSource$.subscribe(tab => {
      this.index = tab;
      this.display = true;
    });

    this._eventBusSub = this._eb.on('logout', () => {
      this._a.logout().subscribe({
        next: (response) => {
          this._am.onMenuClose();
        }
      });
    });
    this._eventBusSub = this._eb.on('no-user-activity', () => {
      this._cs.confirm({
        message: this.translations.tiempoLimiteExpirado,
        header: this.translations.tiempoLimite,
        icon: 'pi pi-exclamation-triangle',
        acceptIcon: "none",
        rejectIcon: "none",
        rejectButtonStyleClass: "p-button-text",
        accept: () => {
          this._uas.resetInactivityTimer();
        },
        reject: () => {
          this._a.logout().subscribe({ next: (response) => {
            this._uas.resetInactivityTimer();
          } });
        }
      });
    });
  }

  async ngOnInit() {
    this.translations = await firstValueFrom(forkJoin({
          tiempoLimiteExpirado: this._t.get('msg.tiempo-limite-expirado'),
          tiempoLimite: this._t.get('msg.tiempo-limite'),
        }));

    this.updateTime();
    this.updateLocation();
  }

  ngOnDestroy(): void {
    if (this._menuOpenSubscription) {
      this._menuOpenSubscription.unsubscribe();
    }
    if (this._menuCloseSubscription) {
      this._menuCloseSubscription.unsubscribe();
    }
    if (this._openTabSubscription) {
      this._openTabSubscription.unsubscribe();
    }
    if (this._eventBusSub) {
      this._eventBusSub.unsubscribe();
    }
  }

    updateTime(): void {
    this.currentTime = new Date();
  }

    updateLocation(): void {
      const now = new Date();
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const offset = -now.getTimezoneOffset() / 60;
      const offsetString = offset >= 0 ? `+${offset}:00` : `${offset}:00`;
      this.location = `${timeZone} ${offsetString}`;
    }

}
